class InfoBanner {
	constructor() {
		this.infoBanner();
	}

	infoBanner() {
		const infoBanner = document.getElementById('info-banner');
		const showInfoBanner = document.getElementById('info_banner_is_show');
		const closeInfoBanner = document.getElementById('close-info-banner');
		const linksInfoBanner = document.querySelectorAll('#info-banner a');
		const homePage = document.querySelector('body.home');
		const saveToStorage = true;

		if (infoBanner && homePage) {
			if (showInfoBanner) {
				if (showInfoBanner.getAttribute('value') === '1') {
					if (!localStorage.getItem('info_banner_close')) {
						document.addEventListener('DOMContentLoaded', function () {
							setTimeout(() => {
								infoBanner.classList.add('active');
							}, 1000);
						});
					}
				}
			} else {
				if (!localStorage.getItem('info_banner_close')) {
					document.addEventListener('DOMContentLoaded', function () {
						setTimeout(() => {
							infoBanner.classList.add('active');
						}, 1000);
					});
				}
			}

			closeInfoBanner.addEventListener('click', function () {
				infoBanner.classList.remove('active');
				if (saveToStorage) {
					localStorage.setItem('info_banner_close', 'true');
				}
			});

			if (linksInfoBanner) {
				for (let i = 0; i < linksInfoBanner.length; i++) {
					linksInfoBanner[i].addEventListener('click', function () {
						infoBanner.classList.remove('active');
						if (saveToStorage) {
							localStorage.setItem('info_banner_close', 'true');
						}
					});
				}
			}
		}
	}
}

new InfoBanner();
